import { api } from "@/services/api";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import Select from "react-select";
import { AddButton } from "./AddButton";
import { FieldError } from "@/components/FieldError";

import { FieldError as Error } from "react-hook-form";

interface Props {
  isInvalid: boolean;
  error?: Error;
  value: string;
  onChange: (value: string) => void;
  required?: boolean
  title?: boolean
}

export interface OptionType {
  label: string;
  value: string;
}

export function FieldTipoEndereco({
  isInvalid,
  value: _value,
  onChange,
  error,
  required = false,
  title = true,
  ...rest
}: Props) {


  const { data: options, isLoading } = useQuery({
    queryKey: ["tipoendereco"],
    queryFn: () => api.get("/tipo/endereco"),
    select: (response: any) =>
      response.data.map(
        ({
          id,
          nome,
        }: {
          id: string;
          nome: string;
        }): OptionType => ({
          value: String(id),
          label: nome,
        })
      ),
  });

  const value: OptionType = React.useMemo(() => {
    const selected = options?.filter(
      (option: OptionType) => String(option.value) === String(_value)
    );
    if (!options || !selected) {
      return { value: _value, label: "" };
    }
    return (selected || {}) as unknown as OptionType;
  }, [options, _value]);

  return (
    <FormControl isInvalid={isInvalid}>
      {
        title && (
      <FormLabel mb="0.40rem" fontSize={'sm'}>
        {
          required ? '*' : false
        }
        Tipo de Endereço
        <AddButton />
      </FormLabel>         
        )
      }

      <Select
        {...rest}
        isLoading={isLoading}
        isClearable={true}
        isSearchable={true}
        options={options}
        value={value}
        placeholder="Selecione"
        onChange={(newValue) => onChange(newValue?.value || "")}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />

      <FieldError error={error} />
    </FormControl>
  );
}
